export class FrmFURPorCodigoBorrador {
    cfurCodborrador: string;
    cfurFecinicioreg: string;
    cfurClavedenunc: string;
}
